function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-800 px-4 py-8 sm:py-12 transition-colors">
      <div className="max-w-[720px] mx-auto bg-white dark:bg-gray-900 p-6 sm:p-10 md:p-14 rounded-2xl sm:rounded-[32px] shadow-lg dark:shadow-gray-900/50 border border-gray-100 dark:border-gray-700 transition-colors">
        
        <div className="mb-10 text-center">
          <div className="w-16 h-16 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="material-symbols-rounded text-[32px]">verified_user</span>
          </div>
          <h1 className="text-2xl sm:text-[32px] md:text-[36px] font-bold text-gray-900 dark:text-white tracking-tight mb-3 leading-tight">
            Privacy Policy for Prompt Keeper
          </h1>
          <p className="text-gray-500 dark:text-gray-400 text-xs sm:text-[14px] font-medium uppercase tracking-wider">
            Last updated: January 28, 2026
          </p>
        </div>

        <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-base sm:text-[18px] text-center mb-10 font-medium">
          The "Prompt Keeper" respects your privacy.
        </p>

        <div className="space-y-8">
          <div className="border-l-4 border-gray-200 dark:border-gray-600 pl-6 py-1 transition-all hover:translate-x-1 hover:border-blue-600">
            <h2 className="text-lg sm:text-[18px] font-bold text-gray-900 dark:text-white mb-2">
              Data Collection
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-sm sm:text-[16px]">
              We only collect information necessary to provide our services: email, display name, and the prompts you create. 
              We do not sell or share your personal information with third parties.
            </p>
          </div>

          <div className="border-l-4 border-gray-200 dark:border-gray-600 pl-6 py-1 transition-all hover:translate-x-1 hover:border-blue-600">
            <h2 className="text-lg sm:text-[18px] font-bold text-gray-900 dark:text-white mb-2">
              Local Storage
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-sm sm:text-[16px]">
              All your data is stored securely on our servers with encryption. 
              Passwords are hashed using bcrypt and cannot be read even by administrators.
            </p>
          </div>

          <div className="border-l-4 border-gray-200 dark:border-gray-600 pl-6 py-1 transition-all hover:translate-x-1 hover:border-blue-600">
            <h2 className="text-lg sm:text-[18px] font-bold text-gray-900 dark:text-white mb-2">
              Your Rights
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-sm sm:text-[16px]">
              You have the right to access, edit, or delete your personal data at any time. 
              You can also request to export all of your data.
            </p>
          </div>

          <div className="border-l-4 border-gray-200 dark:border-gray-600 pl-6 py-1 transition-all hover:translate-x-1 hover:border-blue-600">
            <h2 className="text-lg sm:text-[18px] font-bold text-gray-900 dark:text-white mb-2">
              Cookies
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-sm sm:text-[16px]">
              We use cookies to maintain login sessions and improve user experience. 
              You can disable cookies in your browser, but some features may not work properly.
            </p>
          </div>

          <div className="border-l-4 border-gray-200 dark:border-gray-600 pl-6 py-1 transition-all hover:translate-x-1 hover:border-blue-600">
            <h2 className="text-lg sm:text-[18px] font-bold text-gray-900 dark:text-white mb-2">
              Contact
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-sm sm:text-[16px]">
              If you have any questions about our privacy policy, please contact:{' '}
              <a 
                href="mailto:hainam.pham91@gmail.com" 
                className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium underline decoration-blue-200 dark:decoration-blue-600 underline-offset-4 transition-colors"
              >
                hainam.pham91@gmail.com
              </a>
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-100 dark:border-gray-700 text-center">
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            © 2026 Prompt Library. FPT Polytechnic Student Project.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
